var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';
import UIOptionMenu from '../../../../core/components/OptionMenu';
import Skeleton from '../../../../core/components/Skeleton';
export const OptionMenu = UIOptionMenu;
export const PostContainer = styled((_a) => {
    var { className, isHighlighted } = _a, props = __rest(_a, ["className", "isHighlighted"]);
    return (React.createElement("div", Object.assign({ className: cx('post', className) }, props)));
}) `
  padding: 1rem;
  padding-bottom: 0.5rem;
  background: ${({ theme }) => theme.palette.system.background};
  border: 1px solid #edeef2;
  border-radius: 0;
  position: relative;

  ${({ isHighlighted, theme }) => isHighlighted &&
    `padding-top: 3rem
  `}
`;
export const PostHighlight = styled.div `
  color: white;
  text-transform: uppercase;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  ${({ theme }) => theme.typography.label}

  ${({ theme }) => `background-color: ${theme.palette.primary.main};
  `}
  padding: 0.25rem 0.5rem;
`;
export const PostHeadContainer = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;
export const ReviewButtonsContainer = styled.div `
  border-top: 1px solid ${({ theme }) => theme.palette.base.shade4};
  margin-top: 6px;
  padding-top: 12px;
  display: flex;

  > * {
    flex: 1 1 0;

    &:not(:first-child) {
      margin-left: 12px;
    }
  }
`;
export const ContentSkeleton = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(Skeleton, { style: { fontSize: 8, maxWidth: 374 } })),
        React.createElement("div", null,
            React.createElement(Skeleton, { style: { fontSize: 8, maxWidth: 448 } })),
        React.createElement("div", { style: { paddingBottom: 50 } },
            React.createElement(Skeleton, { style: { fontSize: 8, maxWidth: 279 } }))));
};
//# sourceMappingURL=styles.js.map